import { useSelector } from 'react-redux';

const useClusteredRespondents = () => {
  const backgroundData = useSelector((state) => state.resonance.backgroundData);

  if (!backgroundData || !backgroundData.length) {
    return null;
  }

  const firstAudience = backgroundData[0];
  return firstAudience.respondents;
};

export default useClusteredRespondents;
